/* cro-collection: client-side filters (Size / Color / Price) over the
   natively-rendered grid. Values are built from each card's data-cro-*
   attributes (added in product-grid-item.liquid for this template only).
   Runs only when the cro-collection markup is present. */
(function () {
  function init() {
    var root = document.querySelector("[data-cro-col]");
    if (!root) return;

    // center the active category tab in the scroller on load (mirrors the home tabs)
    var croCatbar = root.querySelector(".cro-col-catbar");
    var croActiveCat = croCatbar && croCatbar.querySelector(".cro-col-cat.is-on");
    if (croCatbar && croActiveCat) {
      croCatbar.scrollLeft = croActiveCat.offsetLeft - (croCatbar.clientWidth - croActiveCat.clientWidth) / 2;
    }
    // carry filter params when switching category tabs
    var catLinks = croCatbar ? croCatbar.querySelectorAll("a.cro-col-cat") : [];
    catLinks.forEach(function (a) {
      a.addEventListener("click", function (e) {
        var fp = filterParams();
        if (!fp.toString()) return;
        e.preventDefault();
        var url = new URL(a.href, window.location.origin);
        fp.forEach(function (v, k) { url.searchParams.set(k, v); });
        window.location.href = url.toString();
      });
    });

    // native sort: reload with ?sort_by (preserves ?view=...). There can be
    // more than one control (-d desktop adds a select inside the drawer).
    root.querySelectorAll("[data-cro-sort]").forEach(function (sortSel) {
      sortSel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortSel.value);
        window.location.href = url.toString();
      });
    });

    var grid = document.querySelector(".boost-pfs-filter-products, .collection-grid");
    var cards = Array.prototype.slice.call(
      document.querySelectorAll(".grid-product[data-cro-price]")
    );
    if (!cards.length) return;

    // ---- size order ----
    var SIZE_ORDER = ["xxs","xs","s","s/m","m","m/l","l","xl","xxl","xxxl","one size","onesize","os"];
    function sizeRank(s) { var i = SIZE_ORDER.indexOf(s); return i === -1 ? 99 : i; }

    // ---- color palette + keyword map (first match wins) ----
    var COLOR_MAP = [
      { key: "Black",  hex: "#141414", kw: ["black","negro","jet","onyx"] },
      { key: "Grey",   hex: "#8c8c8c", kw: ["grey","gray","gris","charcoal","graphite","slate","ash"] },
      { key: "White",  hex: "#ffffff", kw: ["white","blanco","ecru","cream","ivory","optic","off"] },
      { key: "Brown",  hex: "#5b3a1e", kw: ["brown","marron","chocolate","coffee","mocha","tobacco"] },
      { key: "Beige",  hex: "#d8c4a0", kw: ["beige","sand","stone","khaki","oat","natural","taupe","camel","tan","clay"] },
      { key: "Yellow", hex: "#e8c200", kw: ["yellow","amarillo","mustard","gold"] },
      { key: "Red",    hex: "#c0392b", kw: ["red","rojo","burgundy","wine","maroon","rust"] },
      { key: "Blue",   hex: "#27408b", kw: ["blue","azul","navy","indigo","denim","cobalt","teal"] },
      { key: "Green",  hex: "#3a5f0b", kw: ["green","verde","olive","forest","sage","military"] }
    ];
    function colorBucket(text) {
      if (!text) return null;
      text = text.toLowerCase();
      for (var i = 0; i < COLOR_MAP.length; i++) {
        var kws = COLOR_MAP[i].kw;
        for (var j = 0; j < kws.length; j++) {
          if (text.indexOf(kws[j]) !== -1) return COLOR_MAP[i].key;
        }
      }
      return null;
    }

    // ---- read card data ----
    var sizeSet = {}, colorSet = {}, minP = Infinity, maxP = -Infinity;
    cards.forEach(function (c) {
      c._sizes = (c.getAttribute("data-cro-sizes") || "").split("|").filter(Boolean).filter(function (s) { return s !== "default title"; });
      c._sizes.forEach(function (s) { sizeSet[s] = true; });
      c._color = colorBucket(c.getAttribute("data-cro-color") || "");
      if (c._color) colorSet[c._color] = true;
      c._price = parseFloat(c.getAttribute("data-cro-price")) || 0;
      if (c._price < minP) minP = c._price;
      if (c._price > maxP) maxP = c._price;
    });
    minP = Math.floor(minP); maxP = Math.ceil(maxP);

    // ---- URL persistence helpers ----
    function readURL() {
      var p = new URLSearchParams(window.location.search);
      var s = {}, c = {};
      (p.get("f_sizes") || "").split(",").filter(Boolean).forEach(function (v) { if (sizeSet[v]) s[v] = true; });
      (p.get("f_colors") || "").split(",").filter(Boolean).forEach(function (v) { c[v] = true; });
      var pl = parseFloat(p.get("f_plo")), ph = parseFloat(p.get("f_phi"));
      return { sizes: s, colors: c, plo: isNaN(pl) ? minP : Math.max(pl, minP), phi: isNaN(ph) ? maxP : Math.min(ph, maxP) };
    }
    function filterParams() {
      var p = new URLSearchParams();
      var sk = Object.keys(selSizes); if (sk.length) p.set("f_sizes", sk.join(","));
      var ck = Object.keys(selColors); if (ck.length) p.set("f_colors", ck.join(","));
      if (loP > minP) p.set("f_plo", loP);
      if (hiP < maxP) p.set("f_phi", hiP);
      return p;
    }
    function writeURL() {
      var url = new URL(window.location.href);
      ["f_sizes","f_colors","f_plo","f_phi"].forEach(function (k) { url.searchParams.delete(k); });
      filterParams().forEach(function (v, k) { url.searchParams.set(k, v); });
      history.replaceState(null, "", url.toString());
    }

    // ---- state (restore from URL) ----
    var restored = readURL();
    var selSizes = restored.sizes, selColors = restored.colors, loP = restored.plo, hiP = restored.phi;

    // ---- build size pills ----
    var sizesWrap = root.querySelector("[data-cro-sizes]");
    var sizes = Object.keys(sizeSet).sort(function (a, b) {
      var r = sizeRank(a) - sizeRank(b); return r !== 0 ? r : a.localeCompare(b);
    });
    if (sizes.length) {
      root.querySelector('[data-cro-group="size"]').hidden = false;
      sizes.forEach(function (s) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cro-col-pill" + (selSizes[s] ? " is-on" : "");
        b.textContent = s.toUpperCase();
        b.addEventListener("click", function () {
          if (selSizes[s]) { delete selSizes[s]; b.classList.remove("is-on"); }
          else { selSizes[s] = true; b.classList.add("is-on"); }
          updateLabel();
        });
        sizesWrap.appendChild(b);
      });
    }

    // ---- build color dots ----
    var colorsWrap = root.querySelector("[data-cro-colors]");
    var presentColors = COLOR_MAP.filter(function (c) { return colorSet[c.key]; });
    if (presentColors.length) {
      root.querySelector('[data-cro-group="color"]').hidden = false;
      presentColors.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "cro-col-color" + (selColors[c.key] ? " is-on" : "");
        b.innerHTML = '<span class="cro-col-color__dot" style="background:' + c.hex + '"></span>' + c.key;
        b.addEventListener("click", function () {
          if (selColors[c.key]) { delete selColors[c.key]; b.classList.remove("is-on"); }
          else { selColors[c.key] = true; b.classList.add("is-on"); }
          updateLabel();
        });
        colorsWrap.appendChild(b);
      });
    }

    // ---- price dual-range ----
    var lo = root.querySelector("[data-cro-range-lo]");
    var hi = root.querySelector("[data-cro-range-hi]");
    var fill = root.querySelector("[data-cro-range-fill]");
    var lblMin = root.querySelector("[data-cro-price-min]");
    var lblMax = root.querySelector("[data-cro-price-max]");
    // format in the ACTIVE market currency (GBP for UK, EUR for EU, USD, NOK…)
    // — data-cro-price is already localized by Shopify per market; only the
    // symbol was hardcoded before.
    var croCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
    function money(n) {
      try {
        return new Intl.NumberFormat("en", { style: "currency", currency: croCurrency, maximumFractionDigits: 0 }).format(Math.round(n));
      } catch (e) {
        return croCurrency + " " + Math.round(n);
      }
    }
    if (maxP > minP) {
      var rangeEl = root.querySelector("[data-cro-range]");
      root.querySelector('[data-cro-group="price"]').hidden = false;
      [lo, hi].forEach(function (el) { el.min = minP; el.max = maxP; el.step = 1; });
      lo.value = loP; hi.value = hiP;
      function drawRange() {
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
        loP = a; hiP = b;
        var span = maxP - minP || 1;
        fill.style.left = ((a - minP) / span * 100) + "%";
        fill.style.right = (100 - (b - minP) / span * 100) + "%";
        lblMin.textContent = money(a);
        lblMax.textContent = money(b);
      }
      // Robust drag: tap/drag ANYWHERE on the track moves the nearest handle.
      // Pointer Events cover mouse + touch uniformly — the old overlapping
      // range <input> thumbs (pointer-events trick) were unreliable to grab on
      // mobile; the native inputs are now visual-only, driven from here.
      function valueFromX(clientX) {
        var r = rangeEl.getBoundingClientRect();
        if (r.width <= 0) return minP;
        var pct = (clientX - r.left) / r.width;
        pct = pct < 0 ? 0 : (pct > 1 ? 1 : pct);
        return Math.round(minP + pct * (maxP - minP));
      }
      var activeThumb = null;
      function moveTo(clientX) {
        var v = valueFromX(clientX);
        if (activeThumb === null) activeThumb = Math.abs(v - +lo.value) <= Math.abs(v - +hi.value) ? lo : hi;
        if (activeThumb === lo) { if (v > +hi.value) v = +hi.value; lo.value = v; }
        else { if (v < +lo.value) v = +lo.value; hi.value = v; }
        drawRange(); updateLabel();
      }
      rangeEl.addEventListener("pointerdown", function (e) {
        activeThumb = null;
        if (rangeEl.setPointerCapture) { try { rangeEl.setPointerCapture(e.pointerId); } catch (x) {} }
        moveTo(e.clientX); e.preventDefault();
      });
      rangeEl.addEventListener("pointermove", function (e) {
        if (activeThumb === null) return;
        moveTo(e.clientX); e.preventDefault();
      });
      function endDrag() { activeThumb = null; }
      rangeEl.addEventListener("pointerup", endDrag);
      rangeEl.addEventListener("pointercancel", endDrag);
      // keyboard a11y still works on the native inputs
      lo.addEventListener("input", function () { if (+lo.value > +hi.value) lo.value = hi.value; drawRange(); updateLabel(); });
      hi.addEventListener("input", function () { if (+hi.value < +lo.value) hi.value = lo.value; drawRange(); updateLabel(); });
      drawRange();
    }

    // ---- filter ----
    var countEl = root.querySelector("[data-cro-count]");
    // grid columns per viewport: 2 on mobile (small--one-half), 4 on desktop
    // (medium-up--one-quarter). Must be computed per-apply — a fixed 2 wrote
    // clear:both every 2 cards and squashed the desktop grid to two columns.
    function perRowNow() {
      return window.matchMedia && window.matchMedia("(min-width: 769px)").matches ? 4 : 2;
    }
    function apply() {
      var perRow = perRowNow();
      var sizeKeys = Object.keys(selSizes), colorKeys = Object.keys(selColors);
      var shown = 0;
      cards.forEach(function (c) {
        var sizeOk = !sizeKeys.length || c._sizes.some(function (s) { return selSizes[s]; });
        var colorOk = !colorKeys.length || (c._color && selColors[c._color]);
        var priceOk = c._price >= loP && c._price <= hiP;
        var ok = sizeOk && colorOk && priceOk;
        c.style.display = ok ? "" : "none";
        if (ok) {
          shown++;
          c.style.clear = (shown % perRow === 1) ? "both" : "none";
          if (!c.classList.contains("aos-animate")) c.classList.add("aos-animate");
        }
      });
      if (countEl) countEl.textContent = shown + " products";
    }

    // ---- CTA label: "Apply (n)" while filters are pending, else "View results".
    //      Filters are applied to the grid ONLY when the button is clicked, so
    //      closing the sheet visibly updates the results. ----
    var applyBtn = root.querySelector("[data-cro-apply]");
    function filterCount() {
      return Object.keys(selSizes).length + Object.keys(selColors).length + ((loP > minP || hiP < maxP) ? 1 : 0);
    }
    function matchCount() {
      var sizeKeys = Object.keys(selSizes), colorKeys = Object.keys(selColors);
      var n = 0;
      cards.forEach(function (c) {
        var sizeOk = !sizeKeys.length || c._sizes.some(function (s) { return selSizes[s]; });
        var colorOk = !colorKeys.length || (c._color && selColors[c._color]);
        var priceOk = c._price >= loP && c._price <= hiP;
        if (sizeOk && colorOk && priceOk) n++;
      });
      return n;
    }
    function updateLabel() {
      if (!applyBtn) return;
      var n = matchCount();
      applyBtn.textContent = "View results (" + n + ")";
    }
    var fabLabel = root.querySelector(".cro-col-fab span");
    function updateFab() {
      if (!fabLabel) return;
      var n = filterCount();
      fabLabel.textContent = n > 0 ? ("Filter and sort (" + n + ")") : "Filter and sort";
    }

    // ---- open / close ----
    var modal = root.querySelector("[data-cro-modal]");
    function open() { modal.hidden = false; document.documentElement.classList.add("cro-col-modal-open"); }
    function close() { modal.hidden = true; document.documentElement.classList.remove("cro-col-modal-open"); }
    root.querySelectorAll("[data-cro-open]").forEach(function (b) { b.addEventListener("click", open); });
    root.querySelectorAll("[data-cro-close]").forEach(function (b) { b.addEventListener("click", close); });
    if (applyBtn) applyBtn.addEventListener("click", function () { apply(); writeURL(); updateFab(); close(); });

    // ---- clear ---- (resets the selection; applied on the next Apply)
    var clearBtn = root.querySelector("[data-cro-clear]");
    if (clearBtn) clearBtn.addEventListener("click", function () {
      selSizes = {}; selColors = {}; loP = minP; hiP = maxP;
      root.querySelectorAll(".cro-col-pill.is-on, .cro-col-color.is-on").forEach(function (b) { b.classList.remove("is-on"); });
      if (lo && hi) { lo.value = minP; hi.value = maxP; lo.dispatchEvent(new Event("input")); }
      updateLabel();
    });

    apply();
    updateLabel();
    updateFab();

    // re-flow the clear pattern when the viewport crosses the 2col/4col breakpoint
    var lastPerRow = perRowNow();
    window.addEventListener("resize", function () {
      var now = perRowNow();
      if (now !== lastPerRow) { lastPerRow = now; apply(); }
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
